
<div [formGroup]="orderForm" class="full-width"  >

    <button mat-raised-button color="primary" (click)="addParameter()">Criar um novo parametro</button>
  
 
    <div formArrayName="items" *ngFor="let item of _items.controls; let i = index;" class="full-width">
      <div [formGroupName]="i">
  
 
          <div class="row full-width">
      
            <div class="col-md-2">
              <mat-form-field>
                <input matInput formControlName="level" placeholder="Nível">
              </mat-form-field>
            </div>
  
          <div class="col-md-2">
            <mat-form-field class="row full-width">
              <input matInput formControlName="description" placeholder="Descricao">
            </mat-form-field>
          </div>
  
          <div class="col-md-2">
            <mat-form-field>
              <number-list placeholder="Premiações em números" formControlName="numberAwards" [isTextArea]="false"></number-list>
            </mat-form-field>
          </div>
          <div class="col-md-2">
            <mat-form-field>
              <number-list placeholder="Premiações em Coringas" formControlName="jockerAwards" [isTextArea]="false"></number-list>
            </mat-form-field>
          </div>
  
  
  
  
          <div class="col-md-1">
            <button mat-icon-button color="primary" (click)="remove(i)" aria-label="Remover">
              <mat-icon>remove_circle</mat-icon>
            </button>
          </div>
          
          </div>
 
        <br>
      </div>
  
    </div>
  
    </div>
  